import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const sessionId = m[1];
    (async () => {
      try {
        const res = await axios.post(`${API}/auth/google/session`, { session_id: sessionId }, { withCredentials: true });
        setUser(res.data.user);
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user: res.data.user } });
      } catch {
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
    <div className="flex flex-col items-center gap-3">
      <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-primary to-violet-500 animate-pulse" />
      <p className="text-xs uppercase tracking-[0.25em] font-bold text-muted-foreground">Authentification en cours…</p>
    </div>
  </div>;
}
